import { render } from "./ModalSessionTimeout.vue?vue&type=template&id=1470c15d&scoped=true"
import script from "./ModalSessionTimeout.vue?vue&type=script&lang=js"
export * from "./ModalSessionTimeout.vue?vue&type=script&lang=js"

import "./ModalSessionTimeout.vue?vue&type=style&index=0&id=1470c15d&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1470c15d"]])

export default __exports__